import { Chip } from '@/ui/primitives';
import type { Role, User } from '../schemas';

interface Props {
  users: User[];
}

export function UsersStats({ users }: Props) {
  const total = users.length;
  const active = users.filter((u) => u.active).length;
  const inactive = total - active;
  const byRole = users.reduce<Record<string, number>>((acc, u) => {
    acc[u.role] = (acc[u.role] ?? 0) + 1;
    return acc;
  }, {});

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Chip tone="neutral">
        Total · <strong className="ml-1 text-text">{total}</strong>
      </Chip>
      <Chip tone="ok" dot>
        Ativos · <strong className="ml-1">{active}</strong>
      </Chip>
      <Chip tone="danger" dot>
        Inativos · <strong className="ml-1">{inactive}</strong>
      </Chip>
      {(['admin', 'gestor', 'colaborador'] satisfies Role[]).map((r) => (
        <Chip key={r} tone="info">
          {r === 'admin' ? 'Admin' : r === 'gestor' ? 'Gestor' : 'Colaborador'} ·{' '}
          <strong className="ml-1">{byRole[r] ?? 0}</strong>
        </Chip>
      ))}
    </div>
  );
}
